import { useChangeRequest } from "@/services/store/useChangeRequest.ts"

export const useIsExpanderEnabled = () => {
  const changeRequest = useChangeRequest((state) => state.changeRequest)
  return changeRequest?.state === "open" || changeRequest?.state === "draft"
}
